/**
 * Consent page copy — spec §6.2, version 2026-10-16.
 *
 * «Evasione tra sedi»: the client of sede {A} consents (or not) to their request being handed to
 * sede {B}. The owner's own 10-14 edits from the lab's «Modifica testi», every other string
 * harmonised to the formal «Lei» (strings.test.ts guards the register). Italian only (spec §10).
 * Placeholders: {A} sending sede, {B} receiving sede, {comune}, {data} — filled by `riempi`.
 */
export const VERSIONE = '2026-10-16'

export const CONSENSO = {
  tipo: 'Trattamento dati personali',
  titolo: 'Trasferimento dati da {A} a {B}',
  lead: 'Richiesta di conferma accettazione trattamento dati personali privacy',
  cosaRicevera: 'Cosa riceverà {B}',
  cosaRiceveraVoci: [
    'Nome e cognome',
    'Numero di telefono',
    'Indirizzo Email',
    "Indirizzo dell'intervento",
    'Messaggio inserito nella richiesta di sopralluogo',
    'Tipologia di servizio richiesto e preferenze di contatto',
  ],
  chiE: 'Chi è {B}',
  chiEVoci: { denominazione: 'Denominazione', piva: 'P.IVA', indirizzo: 'Indirizzo', telefono: 'Telefono', email: 'Email' },
  informativa: 'Informativa privacy di {B}',
  cosaCambia: 'Cosa cambia',
  cosaCambiaTesto:
    '{B} tratterà i Suoi dati come titolare autonomo per rispondere alla Sua richiesta. {A} conserverà solo la traccia di questo passaggio, oltre alla scheda anonima della richiesta (comune, CAP, servizio, tipo di cliente, ruolo nel condominio, preferenze, data, nota della Sede mittente). Può revocare il consenso in qualsiasi momento scrivendo a {B}; la revoca non ha effetto sul passaggio già avvenuto.',
  whatsappB: 'Acconsento a ricevere da {B} comunicazioni WhatsApp relative alla mia richiesta (facoltativo)',
  whatsappBNota:
    'Il consenso WhatsApp dato a {A} non passa a {B}: senza questa spunta {B} non La contatterà su WhatsApp. Può revocarlo in qualsiasi momento scrivendo a {B}.',
  acconsento: 'Acconsento al passaggio',
  nonAcconsento: 'Non acconsento',
  invio: 'Invio…',
  footer: 'Questa richiesta scade il {data}. Se non risponde, la Sua richiesta resta a {A}.',
  dato: 'Trasferimento della richiesta di sopralluogo avvenuto con successo. La Sua richiesta è ora seguita da {B}, che La contatterà a breve.',
  negato:
    'Non avendo prestato il consenso al trattamento dei dati personali, la Sua richiesta non potrà essere trasferita alla sede {B}. Qualora avesse erroneamente selezionato il rifiuto, contatti {A}.',
  scaduto: 'Questo link è scaduto. La Sua richiesta è rimasta a {A}.',
  annullata: 'Questa richiesta non è più valida.',
  nonTrovato: 'Link non valido.',
  errore: 'Si è verificato un errore. Riprovi più tardi.',
  caricamento: 'Un momento…',
  documentTitle: 'Trattamento dati personali — {A}',
} as const

/** '{A}' → v.A; unknown placeholders stay. */
export function riempi(t: string, v: Record<string, string>): string {
  return t.replace(/\{(\w+)\}/g, (m, k: string) => (k in v ? v[k] : m))
}

/**
 * «28 ottobre 2026» in the sede's time zone. Fractional seconds are cut to milliseconds first:
 * the API may send microseconds, which only the ISO subset every engine must parse leaves out.
 * An unreadable date gives '' rather than «Invalid Date».
 */
export function dataLunga(iso: string): string {
  const d = new Date(iso.replace(/(\.\d{3})\d+/, '$1'))
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Rome' })
}
